import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/landing/Reveal";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";

export default function Privacy() {
  const { t } = useLang();
  useSeo({ title: `${t("privacy.title")} – Nivå Digital`, description: t("privacy.sections")[0].body });
  const sections = t("privacy.sections");
  return (
    <main data-testid="privacy-page" className="min-h-screen bg-ink font-body text-bone">
      <PageHeader />
      <div className="mx-auto max-w-3xl px-4 py-20 sm:px-6">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-mint">{t("privacy.tag")}</p>
          <h1 data-testid="privacy-title" className="mt-4 font-display text-3xl font-black tracking-tight sm:text-4xl">
            {t("privacy.title")}
          </h1>
          <p className="mt-4 text-sm text-fog">{t("privacy.updated")}</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <Reveal key={s.title} delay={0.05 + i * 0.05}>
              <section data-testid={`privacy-section-${i}`}>
                <h2 className="font-display text-lg font-bold tracking-tight text-bone">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-fog">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <div className="mt-16 rounded-2xl border border-white/10 bg-surface p-6">
            <p className="text-sm text-fog">
              {t("privacy.footer1")}{" "}
              <a href="mailto:nivadigitals@gmail.com" className="text-mint hover:underline">
                nivadigitals@gmail.com
              </a>{" "}
              {t("privacy.footer2")} <a href="tel:+46707912901" className="text-mint hover:underline">070-791 29 01</a>.
            </p>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
